import React from 'react';
import Modal from 'react-bootstrap/Modal';
import ExpandingTextArea from 'react-expanding-textarea';
import TextHelpers from 'helpers/TextHelpers';

//-----------------------------------------------------------------

class EditNotesModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            notes: null
        };
    }

    open(opt) {
        return new Promise((resolve) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isChanged: false,
                notes: opt.notes,
                basePostcode: opt.basePostcode,
                showBasePostcode: opt.showBasePostcode
            });
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async saveAndClose() {
        const { notes, basePostcode } = this.state;
        this.close();
        this.resolve({ notes, basePostcode });
    }

    render() {
        const { 
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show onHide={() => this.close()} className="edit-notes-modal" backdrop="static" keyboard={false}>
                <form onSubmit={e => { e.stopPropagation(); e.preventDefault(); this.saveAndClose() }}>
                    <Modal.Body>

                        {this.renderInner()}

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => this.close()}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary ms-auto">
                            Save Changes
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        );
    }

    renderInner() {
        const { isMultiLine } = this.props;
        const { notes, showBasePostcode, basePostcode } = this.state;
        const NotesInputElement = (isMultiLine ? ExpandingTextArea : 'input');

        return (<>
            <div className="form-group mb-3">
                <label className="form-label">Notes</label>
                <NotesInputElement
                    className="form-control"
                    autoFocus
                    value={notes || ''}
                    onChange={e => {
                        const notes = e.target.value;
                        this.setState({
                            notes,
                            isChanged: (notes != this.state.notes)
                        })
                    }}
                    rows={3}
                    onFocus={e => e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
                />
            </div>

            {showBasePostcode &&
                <div className="form-group mb-3">
                    <label className="form-label">Base Postcode / Prefix</label>
                    <input
                        className="form-control"
                        value={basePostcode || ''}
                        onChange={e => {
                            const basePostcode = TextHelpers.normalisePostcode(e.target.value);
                            this.setState({
                                basePostcode,
                                isChanged: (basePostcode != this.state.basePostcode)
                            })
                        }}
                        onFocus={e => e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
                    />
                </div>
            }
        </>);
    }
}

export default EditNotesModal;